var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 2.5C2.94772 2.5 2.5 2.94772 2.5 3.5V11.5C2.5 12.0523 2.94772 12.5 3.5 12.5H11.5C12.0523 12.5 12.5 12.0523 12.5 11.5V8.1C12.5 7.54772 12.9477 7.1 13.5 7.1C14.0523 7.1 14.5 7.54772 14.5 8.1V11.5C14.5 13.1569 13.1569 14.5 11.5 14.5H3.5C1.84315 14.5 0.5 13.1569 0.5 11.5V3.5C0.5 1.84315 1.84315 0.5 3.5 0.5H7.5C8.05228 0.5 8.5 0.947715 8.5 1.5C8.5 2.05228 8.05228 2.5 7.5 2.5H3.5Z",
    fill: "rgba(0, 0, 0, 0.38)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88401 7.22722L11.9989 1L14 2.85782L7.88506 9.08504L5.5 9.5L5.88401 7.22722Z",
    fill: "rgba(0, 0, 0, 0.38)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.67975e7ceccc1d72105aed72ff211cd5.svg";
export { ForwardRef as ReactComponent };